import { buildPublicBookingConfirmationVm } from "./buildPublicBookingConfirmationVm";
import { persistPublicBookingConfirmationSnapshot } from "./publicBookingSnapshot";
import { getPublicBookingConfirmationPath, publicBookingHref } from "./publicBookingPaths";

/**
 * Persist checkout-success snapshot and return the public confirmation href.
 * Call this BEFORE opening HYP so the return tab can hydrate.
 */
export function completePublicVacationPackageBooking({
  order = null,
  selectedResult = null,
  roomsAndPaxInfo = null,
  payableIls = null,
  paymentMethod = null,
  nights = null,
  destination = "",
  boardLabel = "",
  checkIn = "",
  checkOut = "",
  heroImageUrl = "",
  checkoutStatus = "",
} = {}) {
  const vm = buildPublicBookingConfirmationVm({
    order,
    selectedResult,
    roomsAndPaxInfo,
    payableIls,
    paymentMethod,
    nights,
    destination,
    boardLabel,
    checkIn,
    checkOut,
    heroImageUrl,
    checkoutStatus,
  });
  persistPublicBookingConfirmationSnapshot({
    ...vm,
    orderId: vm.technicalOrderId,
    paymentMethod: vm.payment?.method,
  });
  const ref = vm.orderRef || vm.technicalOrderId;
  return {
    vm,
    orderRef: ref,
    href: publicBookingHref(getPublicBookingConfirmationPath(ref)),
  };
}
